<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { BanknotesIcon } from '@heroicons/vue/24/outline';

const rg = useRgStore();
const settings = useSiteStore();
const auth = useAuthStore();
const router = useRouter();

const handleConfirm = () => {
  settings.deactivateModal();
  settings.activateModal('realPlayLaunchAlert');
};

const handleDecline = () => {
  settings.setDemoPlayTimeout();
  settings.deactivateModal();
};

const handleDeposit = () => {
  settings.deactivateModal();
  settings.activateModal('realPlayLaunchAlert');
  router.push('?depositOnLaunch=true');
};

const showDepositButton = computed(
  () =>
    auth.userBalances.cashBalance < 5 &&
    auth.getIsUserCompliant &&
    !rg.accountLocked,
);

onMounted(() => settings.clearDemoPlayTimeout());
</script>

<template>
  <div class="p-4 flex flex-col gap-2 text-center">
    <p class="text-dark-900 dark:text-light-50">
      {{ $t('enjoying-the-game') }}
    </p>
    <p class="text-dark-900 dark:text-light-50">
      {{ $t('suggest-play-for-real') }}
    </p>
  </div>
  <div class="flex flex-col gap-4 p-4 bg-base w-full">
    <div class="flex gap-4 w-full">
      <Button
        type="primary"
        class="w-full justify-center"
        @click="handleConfirm"
      >
        {{ $t('play-real-mode') }}
      </Button>
      <Button
        v-if="showDepositButton"
        type="other"
        class="w-full max-w-[110px] gap-2 justify-center"
        @click="handleDeposit"
      >
        <span>{{ $t('deposit') }}</span>
        <BanknotesIcon class="w-5" />
      </Button>
    </div>

    <Button
      type="secondary-alternative"
      class="w-full justify-center"
      @click="handleDecline"
    >
      {{ $t('continue-demo-play') }}
    </Button>
  </div>
</template>
